import axios from 'axios';
import { setBlockTracking } from 'vue';
import addresstypes from './addresstypes';
import moment from 'moment';
import _ from 'lodash';
import { useLanguageStore } from '../../pinia/LanguageStore';
/** DEPRECATED use pinia languageStore */

// initial state
// shape: [{ id, quantity }]
const state = () => ({
  locale: "en",
  translations: {},
  possible: [],
  loaded: false,
  addNew: false,
  list: [],
  infinity: {
    active: false,
    columns: ["name"],
  },
  allLoaded: false,
})

// getters
const getters = {
  __: (state) => (key, para) => {
    const languageStore = useLanguageStore();
    return languageStore.__(key, para);
  },
  getLanguageByKey: (state) => (key) => {
    const languageStore = useLanguageStore();
    return languageStore.getLanguageByKey(key);
  },
}

// actions
const actions = {
  async load() {
    const languageStore = useLanguageStore();
    await languageStore.load();
  },
  async loadLanguages({ commit, state, rootState }, data) {
    const languageStore = useLanguageStore();
    await languageStore.loadLanguages(data);
  },
}

// mutations
const mutations = {
  setLocale(state, locale) {
    const languageStore = useLanguageStore();
    languageStore.locale = locale;
    languageStore.loaded = false;
  },
  setPossible(state, array) {
        const languageStore = useLanguageStore();
    languageStore.possible = array;
  },
  set(state, data) {
    const languageStore = useLanguageStore();
    languageStore.translations = data;
  },
  loaded(state, status) {
    const languageStore = useLanguageStore();
    languageStore.loaded = status;
  },
  setList(state, list) {
    const languageStore = useLanguageStore();
    if (list == undefined || list.length <= 0) {
      languageStore.allLoaded = true;
    }
    if (languageStore.infinity.active == true) {
      languageStore.list.push(...list);
    } else {
      languageStore.list = list;
    }
  },
  clean(state) {
    const languageStore = useLanguageStore();
    languageStore.list = [];
    languageStore.allLoaded = false;
    languageStore.loaded = false;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
